import { TOAST_ERROR, TOAST_SUCCESS } from 'Constants/actionConstants';
import {
	ABFRL,
	BACARDI,
	  BEAM, 
	  CORAMANDEL, 
	  DEEPAK_PHENOLICS_SAP,
	  DESMET,
	  FINE_TECH,
	  FORSOC,
	  HIKAL,
	  MITSUI,
	  EMAMI,
	  GREEN_PLY,
	  RIL,
	  RIL_RETAIL,
	  RELIANCE_BRANDS,
	  RIL_MIS,
	  COROMANDEL,
	  RIL_DIGITAL
	 } from 'Constants/commonConstants';
import { getActions, getUser } from 'Utils/storage';

export const scroll = (y= 2000, duration = 200) => {
    const initialY =
    document.documentElement.scrollTop || document.body.scrollTop;
    const baseY = (initialY + y) * 0.5;
    const difference = initialY - baseY;
    const startTime = performance.now();

function step() {
    let normalizedTime = (performance.now() - startTime) / duration;
    if (normalizedTime > 1) normalizedTime = 1;

    window.scrollTo(0,baseY + difference * Math.cos(normalizedTime * Math.PI));
    if (normalizedTime < 1) window.requestAnimationFrame(step);
}
window.requestAnimationFrame(step);
};

export const isEqual = function (value, other) {

	// Get the value type
	var type = Object.prototype.toString.call(value);

	// If the two objects are not the same type, return false
	if (type !== Object.prototype.toString.call(other)) return false;

	// If items are not an object or array, return false
	if (['[object Array]', '[object Object]'].indexOf(type) < 0) return false;

	// Compare the length of the length of the two items
	var valueLen = type === '[object Array]' ? value.length : Object.keys(value).length;
	var otherLen = type === '[object Array]' ? other.length : Object.keys(other).length;
	if (valueLen !== otherLen) return false;

	// Compare two items
	var compare = function (item1, item2) {

		// Get the object type
		var itemType = Object.prototype.toString.call(item1);

		// If an object or array, compare recursively
		if (['[object Array]', '[object Object]'].indexOf(itemType) >= 0) {
			if (!isEqual(item1, item2)) return false;
		}

		// Otherwise, do a simple comparison
		else {

			// If the two items are not the same type, return false
			if (itemType !== Object.prototype.toString.call(item2)) return false;

			// Else if it's a function, convert to a string and compare
			// Otherwise, just compare
			if (itemType === '[object Function]') {
				if (item1.toString() !== item2.toString()) return false;
			} else {
				if (item1 !== item2) return false;
			}

		}
	};

	// Compare properties
	if (type === '[object Array]') {
		for (var i = 0; i < valueLen; i++) {
			if (compare(value[i], other[i]) === false) return false;
		}
	} else {
		for (var key in value) {
			if (value.hasOwnProperty(key)) {
				if (compare(value[key], other[key]) === false) return false;
			}
		}
	}

	// If nothing failed, return true
	return true;

};

export function isAdaniWilmar() {
	return ['999', '872'].indexOf(getUser().companyId) > -1;
}

export function downloadUrl(urlLink) {
	localStorage.setItem('teg-component', true);
	const link = document.createElement('a');
	link.href = urlLink;
	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);
}

export function isBeamS(seekerCompany) {
	return (
		BEAM.includes(!!seekerCompany ? seekerCompany : getUser().companyId)
	);
}
export function isBacardi(seekerCompany) {
	return (
		BACARDI.includes(!!seekerCompany ? seekerCompany : getUser().companyId)
	);
}
export function isAbfrl(seekerCompany) {
	return (
		ABFRL.includes(!!seekerCompany ? seekerCompany : getUser().companyId)
	);
}

export function numberWithCommas(x) {
	const regx = new RegExp("/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/", "g");
    return (x.toLocaleString()).replace(regx, ",");
}
export function isMITSUI(seekerCompany) {
	return (
		MITSUI.includes(!!seekerCompany ? seekerCompany : getUser().companyId)
	);
}
export function isSapDPL(seekerCompany) {
	return (
		DEEPAK_PHENOLICS_SAP.includes(!!seekerCompany ? seekerCompany : getUser().companyId)
	);
}
export function isFineTech(seekerCompany) {
	return (
		FINE_TECH.includes(!!seekerCompany ? seekerCompany : getUser().companyId)
	);
}

export function isHikal(seekerCompany) {
	return (
		HIKAL.includes(!!seekerCompany ? seekerCompany : getUser().companyId)
	);
}

export function isFosroc(seekerCompany) {
	return (
		FORSOC.includes(!!seekerCompany ? seekerCompany : getUser().companyId)
	);
}

export function isValueThere(data) {
  const C1 = data !== undefined && data !== null && data !== ''

  if(C1){
	return true
  }

 return false
}

export function isValueThereT1(data) {
  const C1 = data !== undefined && data !== null && data !== '' && data !== 0

  if(C1){
	return true
  }

 return false
}

export function isDesmetSupplier(data) {
	const C1 =  isDesmet() && isSupplier()
  
	if(C1){
	  return true
	}
  
   return false
}

export function isDesmet(seekerCompany) {
	return (
		DESMET.includes(!!seekerCompany ? seekerCompany : getUser().companyId)
	);
}

export function isSupplier() {
  const  actions = getActions() || []
  const  isSupplier = actions.some((ele)=>{
	const C1 = ele.id === 20
	const C2 = ele.name === "Supplier Request"
	if(C1 || C2){
		return true
	}else{
	   return false
	}
  })
  return isSupplier
}

export const toast = ({dispatch , type = 'error' , message ,duration = 5}) => {
    dispatch({
      type: type === 'error' ? TOAST_ERROR : TOAST_SUCCESS,
      message: message,
	  duration
    });
  }

  export const getToFixedValue = (value, fractionDigits = 3) => {
    const C1 = value !== undefined && value !== null && value !== '' && value !== 0 
	 
	if(!C1){
    return 0;
	}
	value = +value
	value  = value.toFixed(fractionDigits)
	return value
  };
export const getSecureRandomKey = () => {
	const array = new Uint32Array(1);
	window.crypto.getRandomValues(array);
	return array[0] / (0xFFFFFFFF + 1);
};


export function isEmami(seekerCompany) {
	return (
		EMAMI.includes(!!seekerCompany ? seekerCompany : getUser().companyId)
	);
};

export function isCoramandel(seekerCompany) {
	return (
		CORAMANDEL.includes(!!seekerCompany ? seekerCompany : getUser().companyId)
	);
}

export function getLegLabel(trip, tripDetails, index){
	let legLabel = '';
	const legData = (trip.legs[0] || {})
	const findIndex = (tripDetails || []).findIndex(el => el.id === trip.id);
	let legIndex = index;
	if(findIndex > -1 && index !== findIndex) {
		legIndex = findIndex
	}
	legLabel = `Leg ${trip.legType} ${legData['shippingLineName'] && `(${legData['shippingLineName']})` || ''}`
	return legLabel;
}

export function isGreenPly(seekerCompany) {
	return (
		GREEN_PLY.includes(!!seekerCompany ? seekerCompany : getUser().companyId)
	);
};

export function isCoromandel(seekerCompany) {
	return (
		COROMANDEL.includes(!!seekerCompany ? seekerCompany : getUser().companyId)
	);
}

export const debounce=(func, delay)=> {
	let timeoutId;
	return function (...args) {
	  clearTimeout(timeoutId);
	  timeoutId = setTimeout(() => {
		func.apply(this, args);
	  }, delay);
	};
  }

export const isRILCompany = (seekerCompany) => {
	let RILRelatedCompanies = [
		...RIL,
		...RIL_RETAIL,
		...FINE_TECH,
		...RELIANCE_BRANDS,
		...RIL_MIS,
		...RIL_DIGITAL
	]
	return (
		RILRelatedCompanies.includes(!!seekerCompany ? seekerCompany : getUser().companyId)
	);
}